var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "addSnapshotFee" }, [
    _c(
      "div",
      { staticClass: "addTable" },
      [
        _c(
          "el-card",
          { staticClass: "mb5" },
          [
            _c("div", { attrs: { slot: "header" }, slot: "header" }, [
              _c("span", [
                _vm._v(_vm._s(_vm.$t("collectionCenter.basicInformation"))),
              ]),
            ]),
            _c(
              "el-form",
              {
                ref: "basicInformation",
                attrs: {
                  model: _vm.addBatchFee.basicInformation,
                  "label-position": "top",
                  size: "mini",
                },
              },
              [
                _c(
                  "el-row",
                  { attrs: { gutter: 10 } },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label:
                                _vm.$t("receivablePayable.TicketNumber") + "：",
                              rules: [
                                {
                                  required: true,
                                  message: _vm.$t("basicData.CannotBeEmpty"),
                                  trigger: ["blur", "change"],
                                },
                                {
                                  max: 30,
                                  message: _vm.$t(
                                    "basicData.LengthCantExceed20"
                                  ),
                                  trigger: ["blur", "change"],
                                },
                              ],
                              prop: "waybillNumber",
                            },
                          },
                          [
                            _c(
                              "div",
                              { staticStyle: { display: "flex" } },
                              [
                                _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      width: "50px",
                                      "font-weight": "bold",
                                      "text-align": "center",
                                    },
                                  },
                                  [_vm._v("QR")]
                                ),
                                _c("el-input", {
                                  attrs: { disabled: !!_vm.queryFeeParam.id },
                                  model: {
                                    value:
                                      _vm.addBatchFee.basicInformation
                                        .waybillNumber,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.addBatchFee.basicInformation,
                                        "waybillNumber",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "addBatchFee.basicInformation.waybillNumber",
                                  },
                                }),
                              ],
                              1
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label:
                                _vm.$t("receivablePayable.customer") + "：",
                              rules: {
                                required: true,
                                message: _vm.$t("basicData.CannotBeEmpty"),
                                trigger: ["blur", "change"],
                              },
                              prop: "customerId",
                            },
                          },
                          [
                            _c("QueryCustomerV2Cmp", {
                              staticStyle: { width: "100%" },
                              attrs: {
                                disabled: !!_vm.queryFeeParam.id,
                                val: _vm.addBatchFee.basicInformation
                                  .customerId,
                              },
                              on: {
                                change: function (val) {
                                  return (_vm.addBatchFee.basicInformation.customerId =
                                    val)
                                },
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label:
                                _vm.$t("basicData.BusinessPrincipal") + "：",
                            },
                          },
                          [_c("span", [_vm._v(_vm._s(_vm.providerName))])]
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("userManage.site") + "：",
                              rules: {
                                required: true,
                                message: _vm.$t("basicData.CannotBeEmpty"),
                                trigger: ["blur", "change"],
                              },
                              prop: "siteId",
                            },
                          },
                          [
                            _c("QuerySiteV2Cmp", {
                              staticStyle: { width: "100%" },
                              attrs: {
                                disabled: !!_vm.queryFeeParam.id,
                                val: _vm.addBatchFee.basicInformation.siteId,
                                "provider-id": "",
                              },
                              on: {
                                change: function (val) {
                                  return (_vm.addBatchFee.basicInformation.siteId =
                                    val)
                                },
                                row: _vm.changeOutlets,
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label:
                                _vm.$t("receivablePayable.BillableWeight") +
                                "：",
                              rules: {
                                required: true,
                                suffix: 3,
                                negative: "",
                                validator: _vm.priceType,
                                trigger: ["blur", "change"],
                              },
                              prop: "chargeWeight",
                            },
                          },
                          [
                            _c("el-input", {
                              attrs: { disabled: !!_vm.queryFeeParam.id },
                              model: {
                                value:
                                  _vm.addBatchFee.basicInformation.chargeWeight,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.addBatchFee.basicInformation,
                                    "chargeWeight",
                                    $$v
                                  )
                                },
                                expression:
                                  "addBatchFee.basicInformation.chargeWeight",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label:
                                _vm.$t("collectionCenter.businessT") + "：",
                              rules: {
                                required: true,
                                message: _vm.$t("basicData.CannotBeEmpty"),
                                trigger: ["blur", "change"],
                              },
                              prop: "businessType",
                            },
                          },
                          [
                            _c(
                              "el-select",
                              {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  disabled: !!_vm.queryFeeParam.id,
                                  placeholder: _vm.$t(
                                    "GlobalSetObj.pleaseChoose"
                                  ),
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.changeBusinessType()
                                  },
                                },
                                model: {
                                  value:
                                    _vm.addBatchFee.basicInformation
                                      .businessType,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.addBatchFee.basicInformation,
                                      "businessType",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "addBatchFee.basicInformation.businessType",
                                },
                              },
                              _vm._l(_vm.BUSINESS_TYPE, function (item) {
                                return _c("el-option", {
                                  key: item.value,
                                  attrs: {
                                    label: item.label,
                                    value: item.value,
                                  },
                                })
                              }),
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm.addBatchFee.basicInformation.businessType === 1
                      ? [
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label:
                                      _vm.$t("collectionCenter.lanshouTypee") +
                                      "：",
                                    rules: {
                                      required: true,
                                      message: _vm.$t(
                                        "basicData.CannotBeEmpty"
                                      ),
                                      trigger: ["blur", "change"],
                                    },
                                    prop: "collectType",
                                  },
                                },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      staticStyle: { width: "100%" },
                                      attrs: {
                                        disabled: !!_vm.queryFeeParam.id,
                                        placeholder: _vm.$t(
                                          "basicData.PleaseSelect"
                                        ),
                                      },
                                      model: {
                                        value:
                                          _vm.addBatchFee.basicInformation
                                            .collectType,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.addBatchFee.basicInformation,
                                            "collectType",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "addBatchFee.basicInformation.collectType",
                                      },
                                    },
                                    _vm._l(_vm.COLLECT_TYPE, function (item) {
                                      return _c("el-option", {
                                        key: item.value,
                                        attrs: {
                                          label: item.label,
                                          value: item.value,
                                        },
                                      })
                                    }),
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label:
                                      _vm.$t("newOrder.CollectionType") + "：",
                                    rules: {
                                      required: true,
                                      message: _vm.$t(
                                        "basicData.CannotBeEmpty"
                                      ),
                                      trigger: ["blur", "change"],
                                    },
                                    prop: "collectionCategory",
                                  },
                                },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      staticStyle: { width: "100%" },
                                      attrs: {
                                        disabled: !!_vm.queryFeeParam.id,
                                        placeholder: _vm.$t(
                                          "basicData.PleaseSelect"
                                        ),
                                      },
                                      model: {
                                        value:
                                          _vm.addBatchFee.basicInformation
                                            .collectionCategory,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.addBatchFee.basicInformation,
                                            "collectionCategory",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "addBatchFee.basicInformation.collectionCategory",
                                      },
                                    },
                                    _vm._l(
                                      _vm.COLLECTION_CATEGORY_TYPE,
                                      function (item) {
                                        return _c("el-option", {
                                          key: item.value,
                                          attrs: {
                                            label: item.label,
                                            value: item.value,
                                          },
                                        })
                                      }
                                    ),
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ]
                      : _vm._e(),
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("placeOrder.cargoType") + "：",
                              rules: {
                                required: false,
                                message: _vm.$t("basicData.CannotBeEmpty"),
                                trigger: ["blur", "change"],
                              },
                              prop: "cargoType",
                            },
                          },
                          [
                            _c(
                              "el-select",
                              {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  disabled: !!_vm.queryFeeParam.id,
                                  placeholder: _vm.$t("basicData.PleaseSelect"),
                                },
                                model: {
                                  value:
                                    _vm.addBatchFee.basicInformation.cargoType,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.addBatchFee.basicInformation,
                                      "cargoType",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "addBatchFee.basicInformation.cargoType",
                                },
                              },
                              _vm._l(_vm.CARGO_TYPE, function (item, ind) {
                                return _c("el-option", {
                                  key: ind,
                                  attrs: {
                                    label: item.label,
                                    value: item.value,
                                  },
                                })
                              }),
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("receivablePayable.paymentMethod"),
                              rules: {
                                required: true,
                                message: _vm.$t("basicData.CannotBeEmpty"),
                                trigger: ["blur", "change"],
                              },
                              prop: "settlementMethod",
                            },
                          },
                          [
                            _c(
                              "el-select",
                              {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  disabled: !!_vm.queryFeeParam.id,
                                  placeholder: _vm.$t(
                                    "operationCenter.PleaseSelect"
                                  ),
                                  clearable: "",
                                  filterable: "",
                                },
                                model: {
                                  value:
                                    _vm.addBatchFee.basicInformation
                                      .settlementMethod,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.addBatchFee.basicInformation,
                                      "settlementMethod",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "addBatchFee.basicInformation.settlementMethod",
                                },
                              },
                              [
                                _c("el-option", {
                                  attrs: {
                                    label: _vm.$t(
                                      "basicData.PeriodicSettlement"
                                    ),
                                    value: 0,
                                  },
                                }),
                                _c("el-option", {
                                  attrs: {
                                    label: _vm.$t(
                                      "basicData.RechargeSettlement"
                                    ),
                                    value: 1,
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 24 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("receivablePayable.remark") + "：",
                              rules: {
                                max: 200,
                                message: _vm.$t(
                                  "basicData.LengthCantExceed200"
                                ),
                                trigger: ["blur", "change"],
                              },
                              prop: "remark",
                            },
                          },
                          [
                            _c("el-input", {
                              attrs: {
                                disabled: !!_vm.queryFeeParam.id,
                                rows: 3,
                                type: "textarea",
                              },
                              model: {
                                value: _vm.addBatchFee.basicInformation.remark,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.addBatchFee.basicInformation,
                                    "remark",
                                    $$v
                                  )
                                },
                                expression:
                                  "addBatchFee.basicInformation.remark",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  2
                ),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "el-card",
          { staticClass: "mb5" },
          [
            _c("div", { attrs: { slot: "header" }, slot: "header" }, [
              _c("span", [
                _vm._v(_vm._s(_vm.$t("receivablePayable.FeeBreakdown"))),
              ]),
            ]),
            _c(
              "el-form",
              {
                ref: "addBatchFee",
                staticClass: "error-form",
                attrs: { model: _vm.addBatchFee, size: "mini" },
              },
              [
                _c(
                  "el-table",
                  {
                    key: _vm.expenseSubListKey,
                    attrs: {
                      data: _vm.addBatchFee.expenseSubList,
                      height: _vm.tableHeight,
                      border: "",
                    },
                  },
                  [
                    _c("el-table-column", {
                      attrs: { align: "center", width: "55" },
                      scopedSlots: _vm._u([
                        {
                          key: "header",
                          fn: function () {
                            return [
                              _c("span", {
                                staticClass: "el-icon-plus addStyle",
                                on: { click: _vm.addCost },
                              }),
                            ]
                          },
                          proxy: true,
                        },
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c(
                                "el-popconfirm",
                                {
                                  attrs: {
                                    title: _vm.$t("basicData.AreYouSureDelete"),
                                  },
                                  on: {
                                    confirm: function ($event) {
                                      return _vm.deleteCost(scope)
                                    },
                                  },
                                },
                                [
                                  _c("span", {
                                    staticClass: "el-icon-delete deleteStyle",
                                    attrs: { slot: "reference" },
                                    slot: "reference",
                                  }),
                                ]
                              ),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      attrs: {
                        label: _vm.$t("collectionCenter.businessT"),
                        align: "center",
                        prop: "businessType",
                        width: "180",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "header",
                          fn: function () {
                            return [
                              _c("div", [
                                _c(
                                  "span",
                                  {
                                    staticStyle: {
                                      color: "#f00",
                                      "margin-right": "5px",
                                    },
                                  },
                                  [_vm._v("*")]
                                ),
                                _c("span", [
                                  _vm._v(
                                    _vm._s(_vm.$t("collectionCenter.businessT"))
                                  ),
                                ]),
                              ]),
                            ]
                          },
                          proxy: true,
                        },
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c(
                                "div",
                                { staticClass: "formStyle" },
                                [
                                  !scope.row.isEdit
                                    ? _c("div", [
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              (_vm.BUSINESS_TYPE[
                                                scope.row.businessType
                                              ] &&
                                                _vm.BUSINESS_TYPE[
                                                  scope.row.businessType
                                                ].label) ||
                                                ""
                                            )
                                          ),
                                        ]),
                                      ])
                                    : _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            prop:
                                              "expenseSubList." +
                                              scope.$index +
                                              ".businessType",
                                            rules: {
                                              required: true,
                                              message: _vm.$t(
                                                "basicData.CannotBeEmpty"
                                              ),
                                              trigger: ["blur", "change"],
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            "el-select",
                                            {
                                              staticStyle: { width: "100%" },
                                              attrs: {
                                                placeholder: _vm.$t(
                                                  "operationCenter.PleaseSelect"
                                                ),
                                                clearable: "",
                                                filterable: "",
                                              },
                                              on: {
                                                change: function ($event) {
                                                  return _vm.businessTypeChange(
                                                    scope
                                                  )
                                                },
                                              },
                                              model: {
                                                value: scope.row.businessType,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    scope.row,
                                                    "businessType",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "scope.row.businessType",
                                              },
                                            },
                                            _vm._l(
                                              _vm.businessTypeList,
                                              function (item) {
                                                return _c("el-option", {
                                                  key: item.value,
                                                  attrs: {
                                                    label: item.label,
                                                    value: item.value,
                                                  },
                                                })
                                              }
                                            ),
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                ],
                                1
                              ),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      attrs: {
                        label: _vm.$t("basicData.ExpenseType"),
                        align: "center",
                        prop: "feeName",
                        width: "180",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "header",
                          fn: function () {
                            return [
                              _c("div", [
                                _c(
                                  "span",
                                  {
                                    staticStyle: {
                                      color: "#f00",
                                      "margin-right": "5px",
                                    },
                                  },
                                  [_vm._v("*")]
                                ),
                                _c("span", [
                                  _vm._v(
                                    _vm._s(_vm.$t("basicData.ExpenseType"))
                                  ),
                                ]),
                              ]),
                            ]
                          },
                          proxy: true,
                        },
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c(
                                "div",
                                { staticClass: "formStyle" },
                                [
                                  !scope.row.isEdit
                                    ? _c("div", [
                                        _vm._v(_vm._s(scope.row.feeName)),
                                      ])
                                    : _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            prop:
                                              "expenseSubList." +
                                              scope.$index +
                                              ".feeCode",
                                            rules: {
                                              required: true,
                                              message: _vm.$t(
                                                "basicData.CannotBeEmpty"
                                              ),
                                              trigger: ["blur", "change"],
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            "el-select",
                                            {
                                              staticStyle: { width: "100%" },
                                              attrs: {
                                                placeholder: _vm.$t(
                                                  "operationCenter.PleaseSelect"
                                                ),
                                                clearable: "",
                                                filterable: "",
                                              },
                                              on: {
                                                change: function ($event) {
                                                  return _vm.feeTypeChange(
                                                    scope
                                                  )
                                                },
                                              },
                                              model: {
                                                value: scope.row.feeCode,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    scope.row,
                                                    "feeCode",
                                                    $$v
                                                  )
                                                },
                                                expression: "scope.row.feeCode",
                                              },
                                            },
                                            _vm._l(
                                              scope.row.feeTypeOptionList,
                                              function (item) {
                                                return _c("el-option", {
                                                  key: item.id,
                                                  attrs: {
                                                    label: item.displayName,
                                                    value: item.code,
                                                  },
                                                })
                                              }
                                            ),
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                ],
                                1
                              ),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      attrs: {
                        label: _vm.$t("receivablePayable.AmountReceivable"),
                        align: "center",
                        prop: "fee",
                        width: "120",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "header",
                          fn: function () {
                            return [
                              _c("div", [
                                _c(
                                  "span",
                                  {
                                    staticStyle: {
                                      color: "#f00",
                                      "margin-right": "5px",
                                    },
                                  },
                                  [_vm._v("*")]
                                ),
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "receivablePayable.AmountReceivable"
                                      )
                                    )
                                  ),
                                ]),
                              ]),
                            ]
                          },
                          proxy: true,
                        },
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c(
                                "div",
                                { staticClass: "formStyle" },
                                [
                                  !scope.row.isEdit
                                    ? _c("div", [_vm._v(_vm._s(scope.row.fee))])
                                    : _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            prop:
                                              "expenseSubList." +
                                              scope.$index +
                                              ".fee",
                                            rules: {
                                              required: true,
                                              suffix: 2,
                                              negative: "-?",
                                              validator: _vm.priceType,
                                              trigger: ["blur", "change"],
                                            },
                                          },
                                        },
                                        [
                                          _c("el-input", {
                                            model: {
                                              value: scope.row.fee,
                                              callback: function ($$v) {
                                                _vm.$set(scope.row, "fee", $$v)
                                              },
                                              expression: "scope.row.fee",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                ],
                                1
                              ),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      attrs: {
                        label: _vm.$t("basicData.BusinessTime"),
                        align: "center",
                        prop: "operateTime",
                        width: "220",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "header",
                          fn: function () {
                            return [
                              _c("div", [
                                _c(
                                  "span",
                                  {
                                    staticStyle: {
                                      color: "#f00",
                                      "margin-right": "5px",
                                    },
                                  },
                                  [_vm._v("*")]
                                ),
                                _c("span", [
                                  _vm._v(
                                    _vm._s(_vm.$t("basicData.BusinessTime"))
                                  ),
                                ]),
                              ]),
                            ]
                          },
                          proxy: true,
                        },
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c(
                                "div",
                                { staticClass: "formStyle" },
                                [
                                  !scope.row.isEdit
                                    ? _c("div", [
                                        _vm._v(_vm._s(scope.row.operateTime)),
                                      ])
                                    : _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            prop:
                                              "expenseSubList." +
                                              scope.$index +
                                              ".operateTime",
                                            rules: {
                                              required: true,
                                              message: _vm.$t(
                                                "basicData.CannotBeEmpty"
                                              ),
                                              trigger: ["blur", "change"],
                                            },
                                          },
                                        },
                                        [
                                          _c("el-date-picker", {
                                            staticStyle: { width: "100%" },
                                            attrs: {
                                              placeholder: _vm.$t(
                                                "basicData.SelectADatetime"
                                              ),
                                              type: "datetime",
                                              "value-format":
                                                "yyyy-MM-dd HH:mm:ss",
                                            },
                                            model: {
                                              value: scope.row.operateTime,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  scope.row,
                                                  "operateTime",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "scope.row.operateTime",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                ],
                                1
                              ),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      attrs: {
                        label: _vm.$t("receivablePayable.remark"),
                        align: "center",
                        "min-width": "160",
                        prop: "remark",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              !scope.row.isEdit
                                ? _c("div", [_vm._v(_vm._s(scope.row.remark))])
                                : _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        prop:
                                          "expenseSubList." +
                                          scope.$index +
                                          ".remark",
                                        rules: {
                                          max: 200,
                                          message: _vm.$t(
                                            "basicData.LengthCantExceed200"
                                          ),
                                          trigger: ["blur", "change"],
                                        },
                                      },
                                    },
                                    [
                                      _c("el-input", {
                                        attrs: {
                                          placeholder: _vm.$t(
                                            "GlobalSetObj.pleaseInputContent"
                                          ),
                                        },
                                        model: {
                                          value: scope.row.remark,
                                          callback: function ($$v) {
                                            _vm.$set(scope.row, "remark", $$v)
                                          },
                                          expression: "scope.row.remark",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                            ]
                          },
                        },
                      ]),
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "footer" },
      [
        _c(
          "el-button",
          {
            attrs: { size: "small" },
            on: {
              click: function ($event) {
                return _vm.saveData(1)
              },
            },
          },
          [_vm._v(_vm._s(_vm.$t("orderCenterCont.ShutDown")))]
        ),
        _c(
          "el-button",
          {
            attrs: { size: "small", type: "primary" },
            on: {
              click: function ($event) {
                return _vm.saveData(2)
              },
            },
          },
          [_vm._v(_vm._s(_vm.$t("basicData.Save")))]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }